import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';

import * as yup from 'yup';

/** Budget revenue admin create and update APIs request body - DTO signature */
export interface BudgetRevenueAdminFormInterface {
  /** Budget revenue admin unique code (three digits) */
  code: string;
  /** Budget revenue admin display name */
  name: string;
}

/** Budget revenue admin create and update APIs request body - DTO schema */
export const BudgetRevenueAdminFormDto = SerdeDtoClass.create<BudgetRevenueAdminFormInterface>(CatalogDtosKeysEnum.BUDGET_REVENUE_ADMIN_FORM_DTO, {
  code: {
    label: 'Код',
    serializer: yup
      .string()
      .matches(/^\d{3}$/im, 'Код должен состоять из трех цифр'),
    checkers: [CatalogCheckersEnum.BUDGET_REVENUE_ADMIN_CODE_UNIQUE],
  },
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
});
